import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DailogReplaceCarComponent } from './dailog-replace-car/dailog-replace-car.component';
import { EligibilityFilterComponent } from './eligibility-filter/eligibility-filter.component';
import { SmartWayComponent } from './smart-way/smart-way.component';
import { CompanyCarComponent } from './company-car/company-car.component';
import { PerfectCarComponent } from './perfect-car/perfect-car.component';
import { HowItWorksComponent } from './how-it-works/how-it-works.component';
import { ContentDescriptionComponent } from './content-description/content-description.component';
import { CarSortComponent } from './car-sort/car-sort.component';
import { FilterChipComponent } from './filter-chip/filter-chip.component';
import { CarPaginationComponent } from './car-pagination/car-pagination.component';
import { CarFeaturesComponent } from './car-features/car-features.component';
import { CarSpecsComponent } from './car-specs/car-specs.component';
import { CarFilterPopupComponent } from './car-filter-popup/car-filter-popup.component';
import { BottomFiltersComponent } from './bottom-filters/bottom-filters.component';
import { SortContentComponent } from './sort-content/sort-content.component';
import { SimilarCarsComponent } from './similar-cars/similar-cars.component';
import { PriceFilterComponent } from './price-filter/price-filter.component';
import { CarShortlistPopupComponent } from './car-shortlist-popup/car-shortlist-popup.component';
import { CarCityPopupComponent } from './car-city-popup/car-city-popup.component';
import { CarSortPopupComponent } from './car-sort-popup/car-sort-popup.component';
import { CarFiltersComponent } from './car-filters/car-filters.component';
import { SharedModule } from '../../shared/shared.module';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { OtherBrandsComponent } from './other-brands/other-brands.component';
import { BreadCrumbComponent } from './bread-crumb/bread-crumb.component';
import { NoCostEmiBannerComponent } from './no-cost-emi-banner/no-cost-emi-banner.component';
import { NoCostEmiBankOfferComponent } from './no-cost-emi-bank-offer/no-cost-emi-bank-offer.component';

const MODULES = [
  SharedModule,
  CommonModule,
  PaginationModule,
];


const COMPONENTS = [
  CarFiltersComponent,
  CarSortComponent,
  FilterChipComponent,
  CarPaginationComponent,
  CarFeaturesComponent,
  CarSpecsComponent,
  CarFilterPopupComponent,
  BottomFiltersComponent,
  SortContentComponent,
  SimilarCarsComponent,
  PriceFilterComponent,
  CarShortlistPopupComponent,
  CarCityPopupComponent,
  CarSortPopupComponent,
  DailogReplaceCarComponent,
  EligibilityFilterComponent,
  SmartWayComponent,
  CompanyCarComponent,
  PerfectCarComponent,
  HowItWorksComponent,
  ContentDescriptionComponent,
  OtherBrandsComponent,
  BreadCrumbComponent,
  NoCostEmiBannerComponent,
  NoCostEmiBankOfferComponent,
];

@NgModule({
  declarations: [...COMPONENTS,],
  imports: [...MODULES,],
  exports: [...COMPONENTS, ...MODULES,],
})
export class SharedViewsModule { }
